import photoView from "../index.js";

export default (route, params, options) => ({
    ...photoView(route, params, options),
    favoritedTiles: [],
    syncDebounce: null,

    initWatches() {
        this.$watch('tilesState', (tiles) => {
            this.selectedTiles = Object.values(tiles)
                .filter(tile => tile?.selected == !this.allSelected)
                .map(tile => tile?.id);

            if (this.selectedTiles.length === this.totalTiles) {
                this.allSelected = !this.allSelected;
                this.selectedTiles = []
            }

            this.favoritedTiles = Object.values(tiles)
                .filter(tile => tile?.favorite == !this.favorite)
                .map(tile => tile?.id);

            this.syncWithServer(this.selectedTiles, this.favoritedTiles)
        })
    },

    syncWithServer(selectedTiles, favoritedTiles) {
        if (this.syncDebounce) {
            clearTimeout(this.syncDebounce)
        }

        this.syncDebounce = setTimeout(() => {
            console.log('Syncing with server')
        }, 1000)

    },

    addSelectClick(sectionDiv) {
        sectionDiv.addEventListener('click', (event) => {
            const saveEl = event.target.closest('[data-save-id]');
            const favoriteEl = event.target.closest('[data-favorite-id]');

            if (saveEl) {
                this.selectTile(saveEl.dataset.saveId);
            }

            if (favoriteEl) {
                this.favoriteTile(favoriteEl.dataset.favoriteId);
            }
        });
    },

    selectTile(tileIndex) {
        let tile = this.tilesState[`${tileIndex}`]

        if (tile) {
            tile.selected = !tile.selected
        }

        if (tile.selected) {
            document.getElementById(`save-${tileIndex}`).classList.add('animate-like')
            return
        }

        document.getElementById(`save-${tileIndex}`).classList.add('animate-like')
    },

    favoriteTile(tileIndex) {
        let tile = this.tilesState[`${tileIndex}`]

        if (tile) {
            tile.favorite = !tile.favorite
            tile.selected = tile.favorite ? true : tile.selected
        }
    },

    isFavorite(tileIndex) {
        return this.tilesState[tileIndex]?.favorite
    },

    tileStateObject(image) {
        return {
            id: image.id,
            selected: image.selected || this.allSelected,
            favorite: image.favorite
        };
    },

    getTileElement(image, index) {
        const tileDiv = this.tileTemplate.cloneNode(true)

        tileDiv.style.width = `${this.tileSize.width}px`;
        tileDiv.style.height = `${this.tileSize.height}px`;
        tileDiv.classList.add('bg-gray-700', 'border-transparent')

        tileDiv.setAttribute("data-tile-id", index);

        const img = tileDiv.querySelector('img')
        img.src = image.thumb
        img.setAttribute("data-image-id", image.id);

        tileDiv.insertAdjacentHTML('beforeend', this.fillActionsAndTags(image, index))

        return tileDiv
    },

    fillActionsAndTags(image, index) {
        return `${this.topImageItems(image, index)}${this.bottomImageItems(image, index)}`
    },

    topImageItems(image, index) {
        return `<div class="top-buttons buttons absolute top-0 left-0 w-full h-10 flex items-center justify-end px-2">
            ${this.getFavoriteButton(index)}
        </div>`
    },

    getFavoriteButton(index) {
        const favoriteIcon = `<svg x-show="isFavorite('${index}')" class="w-5 h-5 text-red-400" x-ref="favoritedIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd"></path>
            </svg>`

        const notFavoriteIcon = `<svg x-show="!isFavorite('${index}')" x-ref="unfavoritedIcon" class="m-0.5 w-4 h-4 text-gray-500" viewBox="0 0 20 18" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12.0252 3.0251C13.392 1.65829 15.608 1.6583 16.9749 3.02513C17.757 3.80729 18.0921 4.86645 17.9784 5.88953C17.9174 6.43843 18.3129 6.93287 18.8618 6.99388C19.4107 7.05489 19.9052 6.65938 19.9662 6.11047C20.1441 4.50949 19.619 2.84086 18.3891 1.61091C16.2412 -0.536971 12.7588 -0.536971 10.6109 1.61091L10 2.22185L9.38909 1.61091C7.2412 -0.536971 3.7588 -0.536971 1.61091 1.61091C-0.536971 3.7588 -0.536971 7.2412 1.61091 9.38909L9.29295 17.0711C9.48048 17.2587 9.73484 17.364 10.0001 17.364C10.2653 17.364 10.5196 17.2587 10.7072 17.0711L12.7071 15.0711C13.0976 14.6806 13.0976 14.0475 12.7071 13.6569C12.3166 13.2664 11.6834 13.2664 11.2929 13.6569L10 14.9498L3.02513 7.97487C1.65829 6.60804 1.65829 4.39196 3.02513 3.02513C4.39196 1.65829 6.60804 1.65829 7.97487 3.02513L9.29295 4.3432C9.48049 4.53074 9.73485 4.6361 10.0001 4.63609C10.2653 4.63609 10.5197 4.53072 10.7072 4.34317L12.0252 3.0251Z"
                        fill="currentColor"></path>
                    <path
                        d="M16.5 7C16.5 6.44772 16.0523 6 15.5 6C14.9477 6 14.5 6.44772 14.5 7V9H12.5C11.9477 9 11.5 9.44772 11.5 10C11.5 10.5523 11.9477 11 12.5 11H14.5V13C14.5 13.5523 14.9477 14 15.5 14C16.0523 14 16.5 13.5523 16.5 13V11H18.5C19.0523 11 19.5 10.5523 19.5 10C19.5 9.44772 19.0523 9 18.5 9H16.5V7Z"
                        fill="currentColor"></path>
                </svg>`

        return `<div data-favorite-id="${index}" class="cursor-pointer rounded-full p-1 button hover:opacity-75 bg-gray-100" id="favorite-3-4">
            ${favoriteIcon} ${notFavoriteIcon}
        </div>`
    },

    bottomImageItems(image, index) {
        return `<div class="bottom-buttons buttons absolute bottom-0 w-full h-10 flex items-center px-2 right-0 justify-end">
            ${this.getSelectButton(index)}
        </div>`
    },

    getSelectButton(index) {
        const addToAlbumButton = `
        <div x-show="!isSelected('${index}')" class="flex items-center">
            <span  class="
                    uppercase font-bold text-[10px] tracking-[0.5px]
                    text-gray-600 pt-0.5 mr-0.5 ml-1.5
                ">
                Add to Album
            </span>
            <svg class="w-5 h-5 text-gray-500" x-ref="unsavedIcon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
            </svg>
        </div>`

        const addedToAlbumButton = `
            <svg x-show="isSelected('${index}')" class="w-5 h-5 text-blue-400" x-ref="savedIcon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"></path>
            </svg>`

        return `<div
            x-bind:class="{
                'hover:opacity-75': !isSelected('${index}'),
            }"
            id="save-${index}" data-save-id="${index}"
            class="save-button cursor-pointer rounded-full p-1 bg-gray-100 flex items-center">
            ${addedToAlbumButton} ${addToAlbumButton}
        </div>`
    },

})
